import React from "react";
import { Link } from "react-router-dom";
import { TNPSC_UNIT1_QUESTIONS } from "../data/tnpscUnit1Questions";
import { TNPSC_UNIT2_QUESTIONS } from "../data/tnpscUnit2Questions";
import { TNPSC_UNIT3_QUESTIONS } from "../data/tnpscUnit3Questions";
import { TNPSC_UNIT4_QUESTIONS } from "../data/tnpscUnit4Questions";
import { TNPSC_UNIT5_QUESTIONS } from "../data/tnpscUnit5Questions";
import { TNPSC_UNIT6_QUESTIONS } from "../data/tnpscUnit6Questions";
import { TNPSC_UNIT7_QUESTIONS } from "../data/tnpscUnit7Questions";
import { TNPSC_UNIT8_QUESTIONS } from "../data/tnpscUnit8Questions";
import { TNPSC_UNIT9_QUESTIONS } from "../data/tnpscUnit9Questions";
import { TNPSC_UNIT10_QUESTIONS } from "../data/tnpscUnit10Questions";

// ── TNPSC 554 — unit menu / hub page ────────────────────────────────────────
const UNITS = [
  {
    to: "/tnpsc-unit1",
    icon: "🖥️",
    title: "Unit I — Programming in C, Python & OOP",
    desc: "Data types, control flow, arrays, functions, pointers, structures, Python essentials, and C++ object-oriented programming.",
    concepts: 35,
    questions: TNPSC_UNIT1_QUESTIONS.length,
    color: "#2563eb",
  },
  {
    to: "/tnpsc-unit2",
    icon: "🌳",
    title: "Unit II — Data Structures and Algorithms",
    desc: "Lists, stacks, queues, trees, heaps, sorting, searching, hashing, graph algorithms, and algorithm analysis.",
    concepts: 23,
    questions: TNPSC_UNIT2_QUESTIONS.length,
    color: "#16a34a",
  },
  {
    to: "/tnpsc-unit3",
    icon: "🔧",
    title: "Unit III — Digital Logic and Computer Architecture",
    desc: "Boolean algebra, logic gates, CPU arithmetic, ISA/RISC vs CISC, pipelining hazards, memory hierarchy, cache coherence, and GPU architectures.",
    concepts: 28,
    questions: TNPSC_UNIT3_QUESTIONS.length,
    color: "#d97706",
  },
  {
    to: "/tnpsc-unit4",
    icon: "🗄️",
    title: "Unit IV — Database Management Systems",
    desc: "DBMS fundamentals, file organization, ER/EER modeling, normalization (1NF-5NF, BCNF, DKNF), SQL & query optimization, transactions & concurrency control, RAID, indexing (B-tree/B+ tree), hashing, and OODBMS/ORDBMS.",
    concepts: 35,
    questions: TNPSC_UNIT4_QUESTIONS.length,
    color: "#dc2626",
  },
  {
    to: "/tnpsc-unit5",
    icon: "☁️",
    title: "Unit V — Operating Systems and Cloud Technologies",
    desc: "Computer system organization, interrupts, memory hierarchy, process & thread management, synchronization (mutex/semaphores/monitors), CPU scheduling, deadlocks, memory/virtual memory, file systems & I/O, and cloud computing/virtualization/security/Hadoop.",
    concepts: 47,
    questions: TNPSC_UNIT5_QUESTIONS.length,
    color: "#0891b2",
  },
  {
    to: "/tnpsc-unit6",
    icon: "🧩",
    title: "Unit VI — Software Engineering",
    desc: "Process models (waterfall, RAD, Agile/XP), requirements engineering, DFD & structured analysis, software design & architecture, testing (basis path, black-box, regression), COCOMO estimation, project scheduling/EVA, risk management, and DevOps.",
    concepts: 43,
    questions: TNPSC_UNIT6_QUESTIONS.length,
    color: "#2563eb",
  },
  {
    to: "/tnpsc-unit7",
    icon: "🌐",
    title: "Unit VII — Web Technology",
    desc: "HTML5/CSS3/JavaScript & the DOM/BOM, PHP scripting, core & advanced Java (JDBC, networking, RMI, Applets, AWT), Servlets & MVC architecture, and Node.js/NoSQL/Spring/MERN/MEAN/Flutter.",
    concepts: 37,
    questions: TNPSC_UNIT7_QUESTIONS.length,
    color: "#7c3aed",
  },
  {
    to: "/tnpsc-unit8",
    icon: "🔒",
    title: "Unit VIII — Computer Networks and Security",
    desc: "Network fundamentals, Ethernet/Wi-Fi/Bluetooth, IP addressing/CIDR/ARP/DHCP/ICMP, routing (RIP/OSPF/BGP/IPv6), transport & application layer protocols, mobile computing/MANET/VANET, and cryptography & network security (DES/AES/RSA/PKI/IPSec/TLS).",
    concepts: 41,
    questions: TNPSC_UNIT8_QUESTIONS.length,
    color: "#16a34a",
  },
  {
    to: "/tnpsc-unit9",
    icon: "🔩",
    title: "Unit IX — Microprocessor and Embedded Systems",
    desc: "8085/8086 architecture & interfacing, 8051 microcontroller, ARM RISC architecture & pipelining, embedded system design, Embedded C, and RTOS concepts (scheduling, IPC, real-time constraints, development tools).",
    concepts: 35,
    questions: TNPSC_UNIT9_QUESTIONS.length,
    color: "#dc2626",
  },
  {
    to: "/tnpsc-unit10",
    icon: "⚡",
    title: "Unit X — Electrical, Electronics and its Applications",
    desc: "DC circuit theorems, AC fundamentals & three-phase systems, transformers & electrical machines, semiconductor devices (diodes/BJT/FET/IGBT), op-amps & 555 timer, sensors/ADC/DAC, and power electronics (SMPS/inverters/UPS/solar/protection).",
    concepts: 35,
    questions: TNPSC_UNIT10_QUESTIONS.length,
    color: "#d97706",
  },
];

const S = {
  page: { minHeight:"100vh", background:"linear-gradient(135deg,#0f172a,#1a1a2e)", fontFamily:"'Segoe UI',sans-serif", color:"#e2e8f0", padding:"18px 16px 80px" },
  back: { color:"#94a3b8", fontSize:13, textDecoration:"none" },
  card: (color) => ({
    display:"block", textDecoration:"none", background:"rgba(255,255,255,0.06)",
    border:`1px solid ${color}55`, borderRadius:16, padding:"20px", marginBottom:16,
  }),
};

export default function TnpscMenuPage() {
  return (
    <div style={S.page}>
      <Link to="/" style={S.back}>← Back to Home</Link>

      <div style={{ textAlign:"center", padding:"14px 0 22px" }}>
        <div style={{ fontSize:28, fontWeight:800, color:"#fff" }}>🎓 TNPSC 554</div>
        <div style={{ fontSize:14, fontWeight:600, color:"#fbbf24", marginTop:4 }}>Assistant System Analyst / Assistant System Engineer</div>
        <div style={{ fontSize:12.5, color:"#94a3b8", marginTop:6, maxWidth:480, marginLeft:"auto", marginRight:"auto" }}>
          Concept guides with worked examples, plus objective-type practice questions for every drafted unit. More units are added over time.
        </div>
      </div>

      {UNITS.map(u => (
        <Link key={u.to} to={u.to} style={S.card(u.color)}>
          <div style={{ fontSize:32 }}>{u.icon}</div>
          <div style={{ fontWeight:800, fontSize:17, color:"#fff", marginTop:8 }}>{u.title}</div>
          <div style={{ fontSize:13, color:"#94a3b8", marginTop:6, lineHeight:1.6 }}>{u.desc}</div>
          <div style={{ display:"flex", gap:10, marginTop:12 }}>
            <span style={{ background:u.color, color:"#fff", borderRadius:20, padding:"3px 12px", fontSize:11.5, fontWeight:700 }}>
              {u.concepts} concepts
            </span>
            <span style={{ background:"#b45309", color:"#fff", borderRadius:20, padding:"3px 12px", fontSize:11.5, fontWeight:700 }}>
              {u.questions} practice questions
            </span>
          </div>
        </Link>
      ))}

      <div style={{ textAlign:"center", fontSize:11.5, color:"#64748b", marginTop:20 }}>
        Content is drafted for exam practice and NOT YET human-reviewed — verify against the official syllabus before relying on it.
      </div>
    </div>
  );
}
